<template>
  <v-layout alig-start>
    <v-flex>
      <!-- Inicio de barra de alerta -->
      <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false"
        transition="slide-y-reverse-transition" right>{{ alerta.text }}</v-snackbar>
      <!-- Fin inicio de barra de alerta -->

      <!-- Listado de marca repuesto y opciones de titulo, busqueda, nuevo, etc  -->
      <v-data-table :loading="loading" :headers="headers" :items="marcas" :items-per-page="15" :search="buscar" dense
        class="elevation-3">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="hidden-sm-and-down">MARCAS</v-toolbar-title>
            <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
            <!-- Impresion marca repuesto -->
            <v-btn fab x-small color="info" @click="crearPDF()" class="mr-1">
              <v-icon>print</v-icon>
            </v-btn>
            <!-- Fin Impresion marca repuesto -->
            <v-spacer />
            <!-- Formulario busqueda de marca repuesto -->
            <v-text-field class="text-xs-center" v-model.trim="buscar" append-icon="search" outlined dense
              label="Búsqueda" background-color="blue lighten-5" single-line hide-details></v-text-field>
            <!-- Fin Formulario busqueda de marca repuesto -->
            <v-spacer />
            <!-- Modal crear y modificar marca repuesto -->
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" class="ma-2" v-on="on" small>Nuevo</v-btn>
              </template>
              <v-card>
                <v-toolbar dark dense class="primary" flat>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-form v-model="isValid">
                    <v-row no-gutters class="mt-4">
                      <v-col align="center" cols="12" class="mb-4">
                        <template color="teal" v-if="file">
                          <v-avatar tile size="80">
                            <v-img :src="urlTemporal" @click="$refs.boton.click()" />
                          </v-avatar>
                        </template>
                        <template v-else-if="imagen == ''">
                          <v-avatar tile size="80">
                            <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton.click()" />
                          </v-avatar>
                        </template>
                        <template color="teal" v-else>
                          <v-avatar tile size="80">
                            <img :src="'data:image/png;base64,' + imagen" @click="$refs.boton.click()" />
                          </v-avatar>
                        </template>
                        <input type="file" id="file" ref="boton" accept=".png, .jpg, .jpeg"
                          @change="buscarImagen($event)" class="d-none" />
                      </v-col>
                      <!-- <v-col cols="2" sm="2" md="2">
                        <v-btn color="warning" dark class="mb-2" @click="$refs.boton.click()">
                          <v-icon>image_search</v-icon>
                        </v-btn>
                      </v-col>-->
                      <v-col cols="12">
                        <v-text-field outlined dense v-model.trim="nombre" label="Nombre"
                          :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 2 && v.length <= 30) || 'Nombre debe tener entre 2 a 30 caracteres', Rules.unespacio]"
                          maxlength="30" background-color="blue lighten-5" prepend-inner-icon="short_text" v-uppercase>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field outlined dense v-model.trim="descripcion" label="Descripción"
                          :rules="[v => v.length <= 100 || 'La descripción no debe tener mas de 100 caracteres', Rules.unespacio]"
                          maxlength="100" background-color="blue lighten-5" prepend-inner-icon="notes" v-uppercase>
                        </v-text-field>
                      </v-col>
                      <!-- Mensaje error marca repuesto -->
                      <v-col cols="12" v-if="mensajeMarcaRepuesto != ''">
                        <v-alert text dense type="error">{{ mensajeMarcaRepuesto }}</v-alert>
                      </v-col>
                      <!-- Mensaje error marca repuesto -->
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions class="py-0 pb-4 px-4 justify-center">
                  <v-btn color="error" @click="close" small>
                    <v-icon left>cancel</v-icon>Cancelar
                  </v-btn>
                  <v-btn color="primary" @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid"
                    small>
                    <v-icon left>save</v-icon>Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Fin Modal crear y modificar marca repuesto -->

            <!-- Modal activar, desactivar marca repuesto -->
            <v-dialog v-model="adModal" max-width="290">
              <v-card>
                <v-card-title class="headline" v-if="adAccion == 1">¿Activar Marca?</v-card-title>
                <v-card-title class="headline" v-if="adAccion == 2">¿Desactivar Marca?</v-card-title>
                <v-card-text>
                  Estás a punto de
                  <span v-if="adAccion == 1">Activar</span>
                  <span v-if="adAccion == 2">Desactivar</span>
                  la Marca de Repuesto {{ adNombre }}
                </v-card-text>
                <v-card-actions class="py-0 pb-4 justify-center">
                  <v-btn color="green darken-1" @click="activarDesactivarCerrar" small>Cancelar</v-btn>
                  <v-btn v-if="adAccion == 1" color="orange darken-4" @click="activar" small>Activar</v-btn>
                  <v-btn v-if="adAccion == 2" color="orange darken-4" @click="desactivar" small>Desactivar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Modal activar, desactivar marca repuesto -->
          </v-toolbar>
        </template>
        <!-- Opciones editar, eliminar marca repuesto-->
        <template v-slot:item.imagen="{ item }">
          <template>
            <v-avatar tile size="30">
              <img :src="'data:image/png;base64,' + item.imagen" />
            </v-avatar>
          </template>
        </template>
        <template v-slot:item.condicion="{ item }">
          <template v-if="item.condicion">
            <v-btn rounded x-small color="success" @click="activarDesactivarMostrar(2, item)">Activo</v-btn>
          </template>
          <template v-else>
            <v-btn rounded x-small color="orange darken-2" @click="activarDesactivarMostrar(1, item)">Inactivo</v-btn>
          </template>
        </template>
        <template v-slot:item.opciones="{ item }">
          <v-btn small icon>
            <v-icon color="blue darken-2" @click="editItem(item)">edit</v-icon>
          </v-btn>
          <v-btn small icon>
            <v-icon color="red darken-2" @click="deleteItem(item)">delete_forever</v-icon>
          </v-btn>
        </template>
        <!-- Fin Opciones editar, eliminar marca repuesto -->
      </v-data-table>
      <!-- Fin Listado de marca repuesto y opciones de titulo, busqueda, nuevo, etc  -->
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import { mapState } from "vuex";

export default {
  data() {
    return {
      marcas: [],
      dialog: false,
      headers: [
        { text: "IMAGEN", value: "imagen", sortable: false },
        { text: "NOMBRE", value: "nombre", sortable: false },
        { text: "DESCRIPCIÓN", value: "descripcion", sortable: false },
        { text: "CONDICIÓN", value: "condicion", sortable: false },
        { text: "OPCIÓN", value: "opciones", sortable: false },
      ],
      buscar: "",
      editedIndex: -1,
      idmarca_repuesto: "",
      imagen: "",
      nombre: "",
      descripcion: "",

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      mensajeMarcaRepuesto: "",

      desabilitar: false,

      isValid: true,
      alerta: { snackbar: false, color: "", text: "" },

      file: null,
      urlTemporal: "",

      imagenxdefec:
        "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",

      /* Validaciones */
      Rules: {
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },
  computed: {
    ...mapState(["logo"]),

    formTitle() {
      return this.editedIndex === -1 ? "Nueva Marca" : "Actualizar Marca";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },
  methods: {
    listar() {
      let me = this;

      me.loading = true;
      axios
        .get("api/Marca_Repuestos/Listar")
        .then(function (response) {
          me.marcas = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    guardar() {
      let me = this;
      me.desabilitar = true;

      if (this.editedIndex > -1) {
        axios
          .put("api/Marca_Repuestos/Actualizar", {
            idmarca_repuesto: me.idmarca_repuesto,
            imagen: me.imagen == "" ? me.imagenxdefec : me.imagen,
            nombre: me.nombre,
            descripcion: me.descripcion,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeMarcaRepuesto = error.response.data;
            me.limpiarAlertaError();
          });
      } else {
        axios
          .post("api/Marca_Repuestos/Crear", {
            imagen: me.imagen == "" ? me.imagenxdefec : me.imagen,
            nombre: me.nombre,
            descripcion: me.descripcion,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeMarcaRepuesto = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },

    deleteItem(item) {
      const respta = confirm(
        "¿Estás seguro de que deseas eliminar la marca de repuesto " +
        item.nombre +
        "?"
      );
      if (respta) {
        let me = this;
        axios
          .delete("api/Marca_Repuestos/Eliminar/" + item.idmarca_repuesto)
          .then((response) => {
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            this.listar();
          })
          .catch(function (error) {
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = error.response.data;
          });
      }
    },

    limpiarAlertaError() {
      setTimeout(() => {
        this.mensajeMarcaRepuesto = "";
      }, 3000);
    },

    editItem(item) {
      this.idmarca_repuesto = item.idmarca_repuesto;
      this.imagen = item.imagen;
      this.nombre = item.nombre;
      this.descripcion = item.descripcion;
      this.editedIndex = 1;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.idmarca_repuesto = "";
      this.imagen = "";
      this.nombre = "";
      this.descripcion = "";
      this.file = null;
      this.mensajeMarcaRepuesto = "";
      this.editedIndex = -1;
      this.file = null;
      this.urlTemporal = "";
      // Limpiamos input carga de imagen
      document.getElementById("file").value = [];
    },

    buscarImagen(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 200px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes =
              dataURI.split(",")[0].indexOf("base64") >= 0
                ? atob(dataURI.split(",")[1])
                : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
            //return dataURItoBlob(dataUrl);
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 200,
        })
          .then((resizedImage) => {
            this.imagen = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },

    /* Desactivar, activar marca repuesto */
    desactivar() {
      let me = this;
      axios
        .put("api/Marca_Repuestos/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.nombre;
      this.adId = item.idmarca_repuesto;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },

    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    activar() {
      let me = this;

      axios
        .put("api/Marca_Repuestos/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar marca repuesto */

    crearPDF() {
      var columns = [
        { header: "NOMBRE", dataKey: "nombre" },
        { header: "DESCRIPCION", dataKey: "descripcion" },
        { header: "CONDICION", dataKey: "condicion" },
      ];
      var body = [];

      this.marcas.map(function (x) {
        body.push({
          nombre: x.nombre,
          descripcion: x.descripcion,
          condicion: x.condicion == 1 ? "Activo" : "Inactivo",
        });
      });

      //console.log(body);

      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "LISTADO DE MARCA REPUESTOS",
            doc.internal.pageSize.width / 2,
            45,
            {
              align: "center",
            }
          );
          doc.addImage(imgData, "JPEG", 40, 17, 80, 40);
        }
      };
      // Agregar pie de pagina: numeracion
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
        }
      };

      var imgData = "data:image/png;base64," + this.logo;
      var doc = new jsPDF("p", "pt");

      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        styles: { overflow: "ellipsize", cellWidth: "wrap" },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 8 },
        columnStyles: {
          nombre: { cellWidth: "150" },
          descripcion: { cellWidth: "250" },
          condicion: { cellWidth: "115", halign: "center" },
        },
      });
      // 515 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      doc.save("Marca Repuesto.pdf");
    },
  },
};
</script>